
import { Prop } from 'vue-property-decorator'
import { Vue } from 'vue-class-component'
import ModalBottomNotificationOptions from '@/interfaces/modal-bottom-notification-options'
import { useStore } from 'vuex'
import { ModalImage } from '../../model/modal-image.model'
import { ImageVariable } from '../../model/image-base64.model'

export default class ModalRightFullPageNotification extends Vue {
  @Prop() modalOptions!: ModalBottomNotificationOptions

  private store = useStore()
  private ModalImage = ModalImage
  private noInternetBase64Icon = ImageVariable.NO_INTERNET

  private isClose = false

  getImagePath(fileName: string) {
    const extensions = ['.svg', '.png']
    let path = ''

    // Require file by extension in linear order
    for (let extension of extensions) {
      try {
        /* eslint-disable-next-line @typescript-eslint/no-var-requires */
        path = require('../../assets/img/' + fileName + extension)
      } catch (e) {
        /* eslint:disable:no-empty */
      }

      if (path) break
    }
    return path
  }

  closeModal() {
    this.isClose = true
    setTimeout(() => {
      this.store.state.isOnline = true
      this.store.state.isTimeout = true
    }, 500)
  }
}
